<template>
    <div id="catalog">
        <div class="head">
            <div>
                <p class="title">作业预览</p>
                <p @click="back()"
                   class="back"></p>
            </div>
        </div>
        <template v-if="loading">
            <div class="textarea">
                <p class="title">作业要求</p>
                <p>{{content}}</p>
            </div>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>

    </div>
</template>
<script type="text/ecmascript-6">
import noResouse from 'COMPONENTS/noResouse.vue'
import loadingS from 'COMPONENTS/base/tealoading.vue';
export default {
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            taskId: this.$route.params.taskid,
            loading: false,
            content: '',
        }
    },
    created () {
        this.$http.get(API_URL_TASK_API + '/szyz/check/task/sf_works_show/preview?message_id=' + this.taskId).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.content = res.data[0]
            }
            this.$nextTick(() => {
                this.loading = true;
            })
        })
    },
    methods: {
        back () {
            this.$router.go(-1)
        },

    },
    components: {
        noResouse, loadingS,
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#catalog {
    padding-top: 96px / $ppr;
    background:#fff;
    min-height: 100vh;
}
.head {
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    div {
        width: 100%;
        height: 96px / $ppr;
        position: relative;
        .title {
            width: 100%;
            height: 96px / $ppr;
            text-align: center;
            line-height: 96px / $ppr;
            color: #fff;
            font-size: 34px / $ppr;
        }
        .back {
            display: block;
            width: 76px / $ppr;
            height: 96px / $ppr;
            background: url(./img/choose_back.png) no-repeat;
            background-position: center;
            background-size: 18px / $ppr 34px / $ppr;
            background-repeat: no-repeat;
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;
        }
    }
}
.textarea {
    margin: 24px / $ppr;
    background: #f2f2f2;
    padding: 20px / $ppr 20px / $ppr 120px / $ppr;
    border-radius: 10px / $ppr;
    .title {
        font-size: 30px / $ppr;
        color: #333;
        text-align: center;
        margin-bottom: 20px / $ppr;
        font-weight: bold;
    }
    p {
        color: #333;
    }
}
</style>
